import { useDispatch, useSelector } from "react-redux";
import { brandIdMap } from "../../Search/const/brandIdMap";
import { noticeDetailApi } from "../api/noticeDetailApi";
import { useEffect, useState } from "react";
import { getNoticeDetail } from "../../../modules/reducers/notice/noticeDetail";

const useNoticeDetail = ({ listId }) => {
  const branchIdARS = useSelector((state) => state.checkArsStatus.branchId);
  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );

  const tempUserId = useSelector((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(' ', '+');
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const notice = useSelector((state) => state.noticeDetail.notice);
  const [brandCd, setBrandCd] = useState(null);
  const [branchId, setBranchId] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [listId]);

  useEffect(() => {
    if (selectedBranchId) {
      setBranchId(selectedBranchId);
    } else if (branchIdARS) {
      setBranchId(branchIdARS);
    }
  }, [branchIdARS, selectedBranchId]);

  useEffect(() => {
    setBrandCd(brandIdMap[brandId]?.cd || null);
  }, [brandId]);

  useEffect(() => {
    if (listId) {
      const api = noticeDetailApi(listId);

      if (branchId && userId && brandCd) {
        const data = {
          store_id: branchId,
          user_id: userId,
          biztp: brandCd,
        };
        dispatch(getNoticeDetail({ ...api, data }));
      }
    }
  }, [brandCd, branchId, userId, listId]);

  return { notice };
};

export default useNoticeDetail;
